import { useMutation, useQueryClient } from "@tanstack/react-query";

import { bffAxios } from "@av/config/api-config/axios-config";
import { setCompanyDocumentInCache } from "../company-document-query-cache";

import type {
  ApiDocumentResponse,
  CompanyDocumentView,
  UpdateCompanyDocumentValues,
} from "../types";

export function useUpdateCompanyDocument() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      documentId,
      values,
    }: {
      documentId: string;
      values: UpdateCompanyDocumentValues;
    }) => {
      const { data } = await bffAxios.patch<ApiDocumentResponse<CompanyDocumentView>>(
        `/company-documents/${documentId}`,
        values
      );

      return data.data;
    },
    onSuccess: (document) => setCompanyDocumentInCache(queryClient, document),
  });
}
